import { Link } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";

const TOC = [
  { id: "guarantee", label: "Our 14-day guarantee" },
  { id: "how", label: "How to request a refund" },
  { id: "process", label: "What happens next" },
  { id: "after", label: "After a refund" },
  { id: "bundles", label: "Bundles" },
  { id: "faulty", label: "Faulty or incorrect files" },
  { id: "abuse", label: "Fair use" },
  { id: "eu", label: "Buyers in the EU and UK" },
  { id: "chargebacks", label: "Before disputing a charge" },
  { id: "contact", label: "Contact and Grievance Officer" },
];

const SUMMARY = [
  "Full refund within 14 days of purchase, no questions asked.",
  "Email us with your purchase email or order number.",
  "Refunds go back to your original payment method in 5 to 10 business days.",
  "Faulty files are replaced or refunded at any time.",
];

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="Refund Policy" activePath="/refund-policy" summary={SUMMARY} toc={TOC}>
      <section className="tc__sec" id="guarantee">
        <h2>Our 14-day guarantee</h2>
        <p>Every purchase from our store is covered by a <strong>14-day refund guarantee</strong>. If a product is not right for you, for any reason, you can ask for a full refund within 14 days of your purchase date.</p>
      </section>

      <section className="tc__sec" id="how">
        <h2>How to request a refund</h2>
        <p>Email <a href="mailto:support@rajeshsivacharya.com">support@rajeshsivacharya.com</a> within 14 days of purchase with:</p>
        <ul>
          <li>the email address you used to buy, and</li>
          <li>your order number, if you have it (it is in your confirmation email).</li>
        </ul>
        <p>Telling us why is optional, but it helps us improve.</p>
      </section>

      <section className="tc__sec" id="process">
        <h2>What happens next</h2>
        <ul>
          <li>We acknowledge your request within 48 hours.</li>
          <li>Approved refunds are issued by our Payment Provider, the Merchant of Record, to your original payment method, in full, including any taxes you paid.</li>
          <li>Refunds usually reach your account within 5 to 10 business days, depending on your bank.</li>
        </ul>
      </section>

      <section className="tc__sec" id="after">
        <h2>After a refund</h2>
        <p>Because our products are digital, a refund ends your licence to use the files, and we ask you to delete any copies you have downloaded or printed.</p>
      </section>

      <section className="tc__sec" id="bundles">
        <h2>Bundles</h2>
        <p>The Complete Collection is sold as a single product, so a refund applies to the whole bundle. If only one item in the bundle has a problem, such as a file that will not open, please tell us first: we will usually fix or replace it right away.</p>
      </section>

      <section className="tc__sec" id="faulty">
        <h2>Faulty or incorrect files</h2>
        <p>If a file is damaged, will not open, or is not what was described, we will replace it or refund you, at any time, not only within 14 days. This is in addition to your rights under consumer law.</p>
      </section>

      <section className="tc__sec" id="abuse">
        <h2>Fair use</h2>
        <p>We may decline requests that show clear signs of abuse, such as repeated purchase-and-refund patterns. This never affects your statutory consumer rights.</p>
      </section>

      <section className="tc__sec" id="eu">
        <h2>Buyers in the EU and UK</h2>
        <p>At checkout you agree to immediate delivery of digital content, which ends the statutory 14-day right of withdrawal under EU and UK law once delivery starts. Our own 14-day guarantee above still applies to you in full. See our <Link to="/terms">Terms and Conditions</Link> for details.</p>
      </section>

      <section className="tc__sec" id="chargebacks">
        <h2>Before disputing a charge</h2>
        <div className="tc__note"><p>Please email us before raising a dispute with your bank. A refund from us is faster and simpler for you, and most requests are approved the same day.</p></div>
      </section>

      <section className="tc__sec" id="contact">
        <h2>Contact and Grievance Officer</h2>
        <div className="tc__card">
          <p><strong>Grievance Officer:</strong> Rajesh Nuthalapati</p>
          <p><strong>Email:</strong> <a href="mailto:support@rajeshsivacharya.com">support@rajeshsivacharya.com</a></p>
          <p><strong>Address:</strong> Flat No. 409, Thatipalli Lake View Apartments, 4th Floor, Priyadarshini Colony, Paloncha Town, Bhadradri Kothagudem District, Telangana – 507115</p>
          <p><strong>Hours:</strong> Monday to Friday, 10:00 to 18:00 IST</p>
        </div>
      </section>
    </LegalLayout>
  );
}
